import React from 'react';

function NotFound() {
    return (
        <div className="text-center mt-5">Not found.</div>
    );
}

export default NotFound;
